import { render, staticRenderFns } from "./UserGroupsCard.vue?vue&type=template&id=008b2a44&scoped=true&"
import script from "./UserGroupsCard.vue?vue&type=script&lang=js&"
export * from "./UserGroupsCard.vue?vue&type=script&lang=js&"
import style0 from "./UserGroupsCard.vue?vue&type=style&index=0&id=008b2a44&prod&lang=scss&scoped=true&"
import style1 from "./UserGroupsCard.vue?vue&type=style&index=1&id=008b2a44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008b2a44",
  null
  
)

export default component.exports